import domtoimage from 'dom-to-image';
import Services from 'services';

const getScreenShots = async () => {
  const dataUrl = await domtoimage.toPng(document.body).catch((error) => {
    console.error('oops, something went wrong while taking screenshot!', error);
    return undefined;
  });


  const [type, data] = (dataUrl ?? "").split(',');
  const image = { type, data };

  await Services.liveScreenService.postScreen(image).catch((error) => {
    console.error('oops, something went wrong while sending screenshot to server!', error);
    setTimeout(() => {
      getScreenShots();
    }, 1000); // 1 secondd
  });
};

export default getScreenShots;
